import classNames from "classnames";
import { DetailedHTMLProps, forwardRef, InputHTMLAttributes, useId } from "react";

import styles from "./input-radio-checkbox.module.scss";

type InputFieldProps = DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & {
  error?: string;
  onClearErrors?: () => void;
};

export default forwardRef<HTMLInputElement, InputFieldProps>(function InputRadioCheckbox(
  { error, name, onBlur, onClearErrors, className, children, ...rest },
  ref
) {
  const id = useId();

  return (
    <label
      className={classNames(
        styles.radioCheckboxLabel,
        { [styles.withError]: !!error },
        { [styles.disabled]: rest.disabled },
        className
      )}
      onMouseDown={(e) => e.preventDefault()}
    >
      <input
        {...rest}
        id={id}
        ref={ref}
        name={name}
        onChange={(e) => {
          rest.onChange?.(e);
        }}
        onBlur={(e) => {
          onBlur?.(e);
        }}
        onFocus={() => {
          onClearErrors?.();
        }}
        aria-invalid={error ? "true" : "false"}
        aria-errormessage={`${id}-error`}
      />
      {(!!children || !!error) && (
        <div>
          {children}
          {error && (
            <p id={`${id}-error`} className={styles.errorMessage}>
              {error}
            </p>
          )}
        </div>
      )}
    </label>
  );
});
